const toSnakeCase = (value: string) => value.replace(/([A-Z])/g, (x) => `_${x.toLowerCase()}`).replace(/\[_/, '[');
const toCamelCase = (value: string) => value.replace(/_([a-z])/g, (x, y) => y.toUpperCase());
const camelToSpaceSeparated = (value: string) => value.replace(/([A-Z])/g, (x) => ` ${x.toLowerCase()}`);

const deepHashConvert =
  (func: (s: string) => string) =>
    (obj: any): any => {
      if (Array.isArray(obj)) {
        return obj.map(deepHashConvert(func));
      }

      if (obj === null || typeof obj !== 'object') {
        return obj;
      }

      return Object.keys(obj).reduce((result: any, key) => {
        result[func(key)] = deepHashConvert(func)(obj[key]);

        return result;
      }, {});
    };

export const transformKeysToSnakeCase = deepHashConvert(toSnakeCase);
export const transformKeysToCamelCase = deepHashConvert(toCamelCase);
export const transformCamelToSpaceSeparated = deepHashConvert(camelToSpaceSeparated);
